export const PrintingConstants = {
  previewJobMaxRetries: 20,
  minQuantity: 1,
  maxQuantity: 5000,
};
